import {FullWorkout, PartType} from '../Models/FullWorkout';

export interface UnrolledPart {
    type: PartType;
}

export function unrollParts(fullWorkout: FullWorkout): UnrolledPart[] | null {
    return (
        fullWorkout.training_plan?.intervals.reduce((acc: UnrolledPart[], interval) => {
            for (let i = 0; i < interval.repetitions; i++) {
                interval.parts.forEach((part) => {
                    acc.push({type: part.type});
                });
            }

            return acc;
        }, []) || null
    );
}
